import actions from 'src/modules/event/promote/eventPromoteActions';

const initialData = {
  loading: false,
};

export default (state = initialData, { type, payload }) => {
  if (type === actions.PROMOTE_ALL_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.PROMOTE_ALL_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.PROMOTE_ALL_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.PROMOTE_STARTED) {
    return {
      ...state,
      loading: true,
    };
  }

  if (type === actions.PROMOTE_SUCCESS) {
    return {
      ...state,
      loading: false,
    };
  }

  if (type === actions.PROMOTE_ERROR) {
    return {
      ...state,
      loading: false,
    };
  }

  return state;
};
